
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Prop } from "vue-property-decorator";
import ModeratorSelector from "./moderator-selector.vue";
import metaData from "./metaData.json";
import draggable from "vuedraggable";
@Component({
  components: { draggable, ModeratorSelector },
})
export default class SessionItems extends Vue {
  @Prop() session!: any;
  @Prop() personDataSource!: ListDataSource;
  @Prop() eventId!: number;
  @Prop() scheduleId!: number;
  @Prop() canEdit!: boolean;

  loaded: boolean = false;
  editMode = false;
  personId: any = null;
  dataSource: ListDataSource = new ListDataSource({
    className: "EventSessionModerator",
    config: {},
  });
  items: any = [];
  $message: any;

  async created() {
    this.dataSource.metadata = { properties: metaData.person };
    this.dataSource.items = this.session.eventSessionModerators;

    this.loaded = true;
  }

  async add(personId: number) {
    await this.dataSource.add(
      {
        eventId: +this.eventId,
        eventScheduleId: this.scheduleId,
        eventSessionId: this.session.id,
        personId,
      },
      true,
    );
    this.personId = null;
    this.editMode = false;
  }
}
